import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, Button, Icon } from 'antd';

import { withZones } from '../Zones';
import Form from './Form';
import styles from './styles.module.scss';

export const ZoneEdit = ({ history: { push }, location: { pathname }, zones, id }) => {
  const zone = zones && zones.features.find(({ properties: { tmpId } }) => tmpId === id);

  return (
    <Card
      className={styles.zoneCard}
      title="Éditer la zone"
      extra={(
        <Button
          onClick={() => push(pathname.replace(/\/zone\/.*$/, ''))}
        >
          Retour
        </Button>
      )}
    >
      {zone
        ? <Form zone={zone} />
        : (
          <p>
            <Icon
              type="loading"
              theme="outlined"
              spin
            />
          </p>
        )
      }
    </Card>
  );
};

export default withRouter(withZones(ZoneEdit));



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/ZoneEdit/index.js